import { IonChip } from '@ionic/react';

import styles from '@/components/Tag/Tag.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

import type { ComponentProps, PropsWithChildren } from 'react';

interface TagProps extends ComponentProps<typeof IonChip> {
  variant?: 'blue' | 'gray' | 'green' | 'yellow' | 'beige' | 'error' | 'measurement';
  size?: 'sm' | 'md';
}

export const Tag = ({ children, variant = 'gray', size = 'md', ...props }: PropsWithChildren<TagProps>) => (
  <IonChip className={mergeClassNames(styles.tag, styles[variant], styles[size])} {...props}>
    {children}
  </IonChip>
);
